import type { OnUploadProgess, UUID } from '@pixum/types';
import type { ImageStateUpdater } from '../../../../types/expressDesigner';

export function onUploadProgress(updater: ImageStateUpdater): OnUploadProgess {
  return (uploadId: UUID, uploadedBytes: number, totalBytes: number) =>
    updater.updateImage({
      uuid: uploadId,
      id: uploadId,
      uploadedBytes,
      totalBytes,
    });
}
